/* Pistacho — as contas dos packs, num sitio so.

   O desconto e da Function `pack-discounts` (repo pistacho-packs, extensao
   pack-discounts, cart_lines_discounts_generate_run.ts), automatico no
   carrinho. As paginas so dizem o que o carrinho vai dar — e para isso repetem
   as regras dela tal e qual: mesma ordem, mesmas quantidades, a mesma escolha
   gulosa pela maior poupanca, as unidades mais caras primeiro. Se la mudar,
   muda aqui, e mudam juntas a ficha nova (pdp-2-venda.js) e o Mix and Match
   (mix-and-match.js), que leem daqui.

   window.PistachoPacks = { PACKS, packsDe(linhas), moeda(centimos) }
     linhas: [{ k, cat, c (centimos por unidade), q, e (opcional: centimos de entrega
       dentro do preço de cada unidade — 3900 nas peças da marcenaria, como na Function) }]
   Desde 27-10-2026 (pistacho-packs-9, f4b5f92) a Function desconta a percentagem sobre o
   preço inteiro de cada linha, entrega incluída: as fichas já não passam `e`. O ramo `e`
   fica para o caso de se voltar a descontar só a peça (como de 29-09 a 27-10).
     -> { packs: [{ nome, pct, unidades, menos }], menos (centimos) }
*/
(function () {
  'use strict';

  // Os nomes vem na lingua da pagina: um bloco JSON com data-pistacho-t
  // (sections/pdp-2.liquid, sections/mix-and-match.liquid) traz-los dos
  // locales (os portugueses sao os mesmos da Function).
  var T = {};
  try { var el = document.querySelector('script[data-pistacho-t]'); if (el) T = JSON.parse(el.textContent) || {}; } catch (e) { T = {}; }
  function nome(k) { return T[k] || ''; }

  var PACKS = [
    { nome: nome('pack_quarto_pronto'), pct: 10, slots: { camas: 1, mesasCabeceira: 2, estrados: 1, colchoes: 1 } },
    { nome: nome('pack_quarto_completo'), pct: 8, slots: { camas: 1, mesasCabeceira: 2, estrados: 1 } },
    { nome: nome('pack_quarto_duo'), pct: 5, slots: { camas: 1, mesasCabeceira: 2 } },
    { nome: nome('pack_sala_completa'), pct: 10, slots: { sofas: 1, movelTv: 1, bancos: 1 } },
    { nome: nome('pack_sala_essencial'), pct: 7, slots: { sofas: 1, movelTv: 1 } },
    { nome: nome('pack_sala_lounge'), pct: 6, slots: { sofas: 1, bancos: 1 } },
    { nome: nome('pack_arrumacao'), pct: 7, slots: { aparadores: 1, estantes: 1 } }
  ];

  function packsDe(linhas) {
    var inv = {};
    linhas.forEach(function (l) {
      if (!l.cat) return;
      inv[l.cat] = inv[l.cat] || [];
      for (var n = 0; n < l.q; n++) inv[l.cat].push({ k: l.k, c: l.c - (l.e || 0), e: l.e || 0 });
    });
    Object.keys(inv).forEach(function (c) { inv[c].sort(function (a, b) { return b.c - a.c; }); });
    var achados = [];
    for (var guarda = 0; guarda < 25; guarda++) {
      var melhor = null;
      PACKS.forEach(function (pack) {
        var tomadas = [], da = true;
        Object.keys(pack.slots).forEach(function (cat) {
          if (!da) return;
          var ha = inv[cat] || [];
          if (ha.length < pack.slots[cat]) { da = false; return; }
          tomadas = tomadas.concat(ha.slice(0, pack.slots[cat]));
        });
        if (!da) return;
        var valor = pack.pct / 100 * tomadas.reduce(function (s, u) { return s + u.c; }, 0);
        if (!melhor || valor > melhor.valor) melhor = { pack: pack, tomadas: tomadas, valor: valor };
      });
      if (!melhor) break;
      Object.keys(melhor.pack.slots).forEach(function (cat) { inv[cat].splice(0, melhor.pack.slots[cat]); });
      achados.push(melhor);
    }
    // O desconto e uma percentagem por linha do carrinho: arredonda-se por linha.
    var menos = 0;
    var packs = achados.map(function (a) {
      var porLinha = {}, deste = 0;
      var comEntrega = a.tomadas.some(function (u) { return u.e > 0; });
      if (comEntrega) {
        deste = Math.round(a.tomadas.reduce(function (s, u) { return s + u.c; }, 0) * a.pack.pct / 100);
      } else {
        a.tomadas.forEach(function (u) { porLinha[u.k] = (porLinha[u.k] || 0) + u.c; });
        Object.keys(porLinha).forEach(function (k) { deste += Math.round(porLinha[k] * a.pack.pct / 100); });
      }
      menos += deste;
      return { nome: a.pack.nome, pct: a.pack.pct, unidades: a.tomadas.length, menos: deste };
    });
    return { packs: packs, menos: menos };
  }

  // O mesmo formato do `money` da loja: €1.245,00.
  function moeda(c) {
    var v = (Math.abs(c) / 100).toFixed(2).split('.');
    return '€' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }

  window.PistachoPacks = { PACKS: PACKS, packsDe: packsDe, moeda: moeda };
})();
